import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * ENG-6006: whether a report is being fetched right now.
 *
 * Counted rather than toggled, because a page can have several requests in flight at
 * once — the Dashboard asks for nine figures in one go — and the bar should go out when
 * the last of them lands, not the first.
 *
 * Nothing here knows which page is on screen. The interceptor feeds it, the Reports
 * shell draws it, so a page that is added later gets the bar without doing anything.
 */
@Injectable({ providedIn: 'root' })
export class ReportBusyService {
  private inFlight = 0;
  private readonly state = new BehaviorSubject<boolean>(false);

  /** True while at least one report request is outstanding. */
  readonly busy$ = this.state.asObservable().pipe(distinctUntilChanged());

  started(): void {
    this.inFlight += 1;
    this.state.next(true);
  }

  finished(): void {
    // never below zero: a request cancelled before it was counted would otherwise
    // leave the bar stuck on for the rest of the session
    this.inFlight = Math.max(0, this.inFlight - 1);
    this.state.next(this.inFlight > 0);
  }
}
